
import { defineComponent } from 'vue'
import appHost from '@/utils/app'
export interface ThemeVars {
  borderRadiusMax: string
}
export default defineComponent({
  name: 'App-Contact-Us',
  props: {
    isCanClick: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  setup() {
    const themeVars: ThemeVars = {
      borderRadiusMax: '8px',
    }
    return {
      themeVars,
    }
  },
  methods: {
    onContactUs(): void {
      appHost.postSobotChat()
    },
  },
})
